var _mask, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1643_907",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 8.02924C3 7.38333 3.31193 6.77719 3.83752 6.40177L8.83752 2.83034C9.53292 2.33363 10.4671 2.33363 11.1625 2.83034L16.1625 6.40177C16.6881 6.77719 17 7.38333 17 8.02924V15C17 16.1046 16.1046 17 15 17H5C3.89543 17 3 16.1046 3 15V8.02924Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1625 2.83034L10.5812 3.64407L11.1625 2.83034ZM16.1625 6.40177L16.7437 5.58804L16.1625 6.40177ZM16 8.02924V15H18V8.02924H16ZM15 16H5V18H15V16ZM4 15V8.02924H2V15H4ZM4.41876 7.2155L9.41876 3.64407L8.25629 2.01661L3.25629 5.58804L4.41876 7.2155ZM10.5812 3.64407L15.5812 7.2155L16.7437 5.58804L11.7437 2.01661L10.5812 3.64407ZM9.41876 3.64407C9.76646 3.39572 10.2335 3.39572 10.5812 3.64407L11.7437 2.01661C10.7006 1.27154 9.29938 1.27154 8.25629 2.01661L9.41876 3.64407ZM5 16C4.44772 16 4 15.5523 4 15H2C2 16.6569 3.34315 18 5 18V16ZM16 15C16 15.5523 15.5523 16 15 16V18C16.6569 18 18 16.6569 18 15H16ZM18 8.02924C18 7.06038 17.5321 6.15117 16.7437 5.58804L15.5812 7.2155C15.844 7.40321 16 7.70628 16 8.02924H18ZM4 8.02924C4 7.70628 4.15597 7.40321 4.41876 7.2155L3.25629 5.58804C2.4679 6.15117 2 7.06038 2 8.02924H4Z",
    fill: "#666666",
    mask: "url(#path-1-inside-1_1643_907)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11C8 10.4477 8.44772 10 9 10H11C11.5523 10 12 10.4477 12 11V16.5H8L8 11Z",
    stroke: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.73c0a2245c56f151aa347d03f5759d25.svg";
export { ForwardRef as ReactComponent };